import { render, staticRenderFns } from "./IndicadorCarga.vue?vue&type=template&id=4ccb0073&scoped=true"
import script from "./IndicadorCarga.vue?vue&type=script&lang=js"
export * from "./IndicadorCarga.vue?vue&type=script&lang=js"
import style0 from "./IndicadorCarga.vue?vue&type=style&index=0&id=4ccb0073&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb0073",
  null
  
)

export default component.exports